import { render, staticRenderFns } from "./DateWidget.vue?vue&type=template&id=cc61dd56&scoped=true&"
import script from "./DateWidget.vue?vue&type=script&lang=js&"
export * from "./DateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc61dd56",
  null
  
)

export default component.exports